import type { SupportTicketQueryScope } from "@redotech/redo-support-v2/query/support-ticket-query-keys";
import {
  activeViewStatusCountsBaseQueryKey,
  supportTicketCountsQueryKey,
  supportTicketsPageScopedQueryKey,
} from "@redotech/redo-support-v2/query/support-ticket-query-keys";
import type { QueryClient } from "@tanstack/react-query";
import { supportTicketSummaryBaseQueryKey } from "./db/support-ticket-data-source";

export function invalidateSupportTicketListQueriesAfterDelay({
  queryClient,
  queryScope,
}: {
  queryClient: QueryClient;
  queryScope?: SupportTicketQueryScope;
}) {
  setTimeout(() => {
    void queryClient.invalidateQueries({
      queryKey: supportTicketsPageScopedQueryKey(queryScope),
    });
    void queryClient.invalidateQueries({
      queryKey: supportTicketCountsQueryKey,
    });
    void queryClient.invalidateQueries({
      queryKey: activeViewStatusCountsBaseQueryKey,
    });
    void queryClient.invalidateQueries({
      queryKey: supportTicketSummaryBaseQueryKey,
    });
  }, 2000);
}
